import { compose, filter, find, get, map, split, last, head, size, isNull, first } from 'lodash/fp';
import { TextKey } from '@mews-commander/enums';
import AnalyticsType from './enums/analyticsType';

const removeAnalyticsTypeFromDisplayName = compose(last, split('/'));

const getTypeOrNull = (names: $TSFixMe) => (size(names) > 1 ? head(names) : null);

const getAnalyticsTypeFromDisplayName = compose(getTypeOrNull, split('/'));

export const mapPowerBiPagesToSerializableObjects = map(({ displayName, name, isActive, visibility }) => ({
    name,
    isActive,
    visibility,
    displayName: removeAnalyticsTypeFromDisplayName(displayName),
    analyticsType: getAnalyticsTypeFromDisplayName(displayName),
}));

export const getVisibleTabs = filter({ visibility: 0 });

export const getFirstVisibleTab = compose(first, getVisibleTabs);

export const getTabsByAnalyticsTypeOrIfNull = (analyticsType: AnalyticsType) =>
    filter((t) => isNull((t as $TSFixMe).analyticsType) || (t as $TSFixMe).analyticsType === analyticsType);

export const getTabsFromReportPages = (analyticsType: AnalyticsType) =>
    compose(getTabsByAnalyticsTypeOrIfNull(analyticsType), mapPowerBiPagesToSerializableObjects);

export const getActiveTabName = compose(get('name'), find({ isActive: true }));

export const getVisibleActiveTabName = compose(getActiveTabName, getVisibleTabs);

export const mapAnalyticsTypeTextKey = {
    [AnalyticsType.AgingBalance]: TextKey.AgingBalance,
    [AnalyticsType.Bookings]: TextKey.BookingsReport,
    [AnalyticsType.Manager]: TextKey.ManagerAnalytics,
    [AnalyticsType.Financial]: TextKey.FinancialAnalytics,
    [AnalyticsType.Outlet]: TextKey.OutletAnalytics,
    [AnalyticsType.Pickup]: TextKey.PickupAnalytics,
    [AnalyticsType.DepositLedger]: TextKey.DepositLedger,
    [AnalyticsType.GuestLedger]: TextKey.GuestLedger,
    [AnalyticsType.TrialBalance]: TextKey.TrialBalance,
    [AnalyticsType.Marketing]: TextKey.MarketingAnalytics,
    [AnalyticsType.MultiPropertyMarketing]: TextKey.MultiPropertyMarketingAnalytics,
};
